// 登录 token
import type { CompanyList, Gender } from '@/types/global'

const accessToken = 'Access-Token'

// 刷新 token
const refreshToken = 'Refresh-Token'

// 企业 ID
const companyId = 'Company-Id'

// 用户密码
const password = 'Password'

const TOKEN = 'authorized-token'
// const COMPANYID = 'company-id'
const COMPANYLIST = 'company-list'
// const COMPANYCODE = 'company-code'

export type DataInfo = {
  [k: string]: unknown;
  /* token  */
  access_token: string;
  /* `accessToken` 的过期时间 (时间戳) */
  expires: number;
  /* 刷新 token */
  refresh_token: string;
  /* 性别 */
  gender: Gender;
  /* 是否设置密码 */
  password: boolean;
  /* 公司集合 */
  company: CompanyList;
}

// accesstoken

export function getToken(): DataInfo {
  const tokenString = window.localStorage.getItem(TOKEN) as string
  return JSON.parse(tokenString)
}
export function setToken(data: DataInfo) {
  window.localStorage.setItem(TOKEN, JSON.stringify(data))
}

export const getAccessToken = function () {
  return window.localStorage.getItem(accessToken)
}

export const setAccessToken = function (token: string) {
  window.localStorage.setItem(accessToken, token)
}

export const removeAccessToken = function () {
  window.localStorage.removeItem(accessToken)
}

// refreshtoken
export const getRefreshToken = function () {
  return window.localStorage.getItem(refreshToken)
}

export const setRefreshToken = function (token) {
  window.localStorage.setItem(refreshToken, token)
}

export const removeRefreshToken = function () {
  window.localStorage.removeItem(refreshToken)
}

// companyid
export const getCompanyId = function () {
  return window.localStorage.getItem(companyId)
}

export const setCompanyId = function (id) {
  window.localStorage.setItem(companyId, id)
}

export const removeCompanyId = function () {
  window.localStorage.removeItem(companyId)
}

// password
export const getPassword = function () {
  return window.localStorage.getItem(password)
}

/**
 * @param {boolean} bool - 是否设置密码
 * @returns
 */
export const setPassword = function (bool) {
  window.localStorage.setItem(password, bool)
}

export const removePassword = function () {
  window.localStorage.removeItem(password)
}

export function clearStorage() {
  window.localStorage.clear()
}

export function getCompanyList() {
  try {
    return JSON.parse(window.localStorage.getItem(COMPANYLIST) as string)
  } catch (error) {
    return []
  }
}

export function setCompanyList(payload: any[]) {
  window.localStorage.setItem(COMPANYLIST, JSON.stringify(payload))
}
